var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7365 2.32088H2.24207C1.54064 2.32088 0.979492 1.80513 0.979492 1.16044C0.979492 0.515751 1.54064 0 2.24207 0H20.7365C21.4379 0 21.9991 0.515751 21.9991 1.16044C22.0225 1.80513 21.4379 2.32088 20.7365 2.32088Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8372 8.47972H4.14098C3.5836 8.47972 3.1377 7.96397 3.1377 7.31928C3.1377 6.67459 3.5836 6.15884 4.14098 6.15884H18.8372C19.3946 6.15884 19.8405 6.67459 19.8405 7.31928C19.859 7.96397 19.3946 8.47972 18.8372 8.47972Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9187 14.6386H5.05951C4.57181 14.6386 4.18164 14.1229 4.18164 13.4782C4.18164 12.8335 4.57181 12.3177 5.05951 12.3177H17.9187C18.4064 12.3177 18.7966 12.8335 18.7966 13.4782C18.8128 14.1229 18.4064 14.6386 17.9187 14.6386Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.05fc73142b11864674e32222ab2668f5.svg";
export { ForwardRef as ReactComponent };